import HTTPService from "../utility/httpService";
import { apiEndPointConstants, keyConstants } from "../constants";
import Utils from "../utility";
const { TOKEN } = keyConstants;
const { USER_CONSENTS, USER_CONSENT, FILTER_CONSENT } = apiEndPointConstants;
export default class UserConsentService {
  /**
   * Initializes a new instance of the class.
   *
   * @param {type} token - The token used for authorization.
   */
  constructor(token) {
    this.httpService = new HTTPService(
      process.env.REACT_APP_USER_CONSENT_MICROSERVICE
    );
    this.config = {
      headers: {
        Authorization: `Bearer ${
          token !== undefined ? token : Utils.cookieGetItem(TOKEN)?.access_token
        }`,
        "X-Api-Key": process.env.REACT_APP_X_API_KEY
      }
    };
  }

  /**
   * Retrieves a consent by its business ID.
   *
   * @param {string} businessId - The business ID of the consent.
   * @return {Promise} A promise that resolves with the consent data.
   */
  getConsentById(businessId, skip = 0, limit = 10, queryParams) {
    let url = `${USER_CONSENTS}/${businessId}?skip=${skip}&limit=${limit}`;

    if (queryParams && Object.keys(queryParams).length) {
      for (const [key, value] of Object.entries(queryParams)) {
        if (value) {
          url += `&${key}=${value}`;
        }
      }
    }
    return this.httpService.get(url, {}, this.config);
  }

  /**
   * Retrieves the consent detail by its unique ID.
   *
   * @param {number} consentId - The ID of the consent.
   * @return {Promise} A promise that resolves with the consent detail.
   */
  getConsentDetailById(consentId) {
    const url = `${USER_CONSENT}/${consentId}`;
    return this.httpService.get(url, {}, this.config);
  }
  /**
   * Filters the consent.
   *
   * @param {Object} payload - the payload for filtering consent
   * @return {Array} the result of the filtering process
   */
  filterConsent(payload) {
    return this.httpService.post(FILTER_CONSENT, payload, this.config);
  }
}
